import * as Immutable from "immutable";

import { Action } from "./Action";
import { ActionCentre } from "./ActionCentre";
import { Actions, IAction } from "./types";

export class TelephoneRepresentations {

    private actionCentre: ActionCentre;

    constructor(actionsService: ActionCentre) {
        this.actionCentre = actionsService;
        this.runEventBinding();
    }

    private runEventBinding(): void {
        const body: HTMLElement = document.querySelector("body") as HTMLElement;
        const triggers: NodeListOf<HTMLElement> = document.querySelectorAll("[data-more-info-trigger]") as NodeListOf<HTMLElement>;
        const infoBoxes: NodeListOf<HTMLElement> = document.querySelectorAll("[data-more-info-content]") as NodeListOf<HTMLElement>;
        const closeButtons: NodeListOf<HTMLElement> = document.querySelectorAll("[data-more-info-close]") as NodeListOf<HTMLElement>; 
     
        for (let i = 0; i < triggers.length; i++) {
            triggers[i].addEventListener("click", (e) => {
                e.stopPropagation();
                const action = new Action(Actions.SHOW_OVERLAY, ["showOverlay", true]);
                this.actionCentre.Do(action);
                infoBoxes[i].style.display = "block";
            });

            closeButtons[i].addEventListener("click", (e) => {                
                const action = new Action(Actions.HIDE_OVERLAY, ["showOverlay", false]);
                this.actionCentre.Do(action);
                infoBoxes[i].style.display = "none";
            });
        }

        body.addEventListener("click", () => {
            for (let i = 0; i < triggers.length; i++) {
                closeButtons[i].click();
            }
        });

    }
}



// WEBPACK FOOTER //
// ./src/global/TelephoneRepresentations.ts